import React from 'react';
import clsx from 'clsx';
import { theme } from '../../utils/theme';
import styles from './CalendarEvent.module.scss';
export const CalendarEvent = ({ id, slot, styleType, baseStyle, eventPosition, dayPosition, bannerStyles, label, value, code, onRenderCustomEvent, isPastEvent, labelBackground, }) => {
    // hidden event
    if (slot === -1) {
        return null;
    }
    return (<>
      {styleType === 'normal' && (<div style={{
                borderColor: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.borderColor,
                backgroundColor: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.backgroundColor,
                borderStyle: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.borderStyle,
            }} className={clsx(styles.calendarEvent, styles[baseStyle], styles[`slot${slot}`])} role='presentation'>
          {label && (<span style={{
                    color: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.color,
                }} className={clsx(styles.calendarEventLabel, 'fs-mask')}>
              {label}
            </span>)}
        </div>)}
      {styleType === 'partEx' && (<div className={clsx(styles.calendarEvent, styles.partEx, styles[baseStyle], styles[`slot${slot}`])} role='presentation'>
          {eventPosition === 'start' && (<div style={{
                    color: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.color,
                }} className={clsx(styles.calendarEventLabel, 'fs-mask')}>
              <div className={styles.imageWrapper}>
                <img src='https://www.haven.com/assets/owners/shared/holiday_home.svg' alt=''/>
              </div>
              <div className={styles.text}>
                <p>
                  <b>Pick up new keys!</b>
                </p>
                <p>{label}</p>
              </div>
            </div>)}
        </div>)}
      {styleType === 'dashed' && (<div style={{
                borderColor: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.borderColor,
            }} className={clsx(styles.calendarEvent, styles[baseStyle], styles[`slot${slot}`])} role='presentation'>
          <div className={styles.calendarEventDashedWrapper}>
            {label || value ? (<>
                <div style={{
                    borderColor: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.borderColor,
                }} className={styles.calendarDashedSpanLine}/>
                <span style={{
                    color: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.color,
                    backgroundColor: labelBackground !== null && labelBackground !== void 0 ? labelBackground : (isPastEvent ? theme.colors.lightWhite : theme.colors.white),
                }} className={styles.calendarDashedLabel}>
                  {label && value ? `${label} (£${value})` : label || value}
                </span>
                <div style={{
                    borderColor: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.borderColor,
                }} className={styles.calendarDashedSpanLine}/>
              </>) : (<div style={{
                    borderColor: bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.borderColor,
                }} className={styles.calendarDashedSpanLine}/>)}
          </div>
        </div>)}
      {styleType === 'image' && (<div className={styles[baseStyle]} role='presentation'>
          <img src={bannerStyles === null || bannerStyles === void 0 ? void 0 : bannerStyles.imgUrl} alt='day-event'/>
        </div>)}
      {styleType === 'custom' &&
            onRenderCustomEvent &&
            onRenderCustomEvent({
                id,
                slot,
                styleType,
                baseStyle,
                eventPosition,
                dayPosition,
                bannerStyles,
                label,
                value,
                code,
            })}
    </>);
};
